import { Navigate, useLocation, useParams } from "react-router-dom";
import { legacyShipmentsRedirect, legacyWarehouseRedirect } from "@/lib/fulfilment-workspace";

export function RedirectLegacyWarehouse() {
  const { id } = useParams();
  const { pathname } = useLocation();
  return <Navigate to={legacyWarehouseRedirect(pathname, id)} replace />;
}

export function RedirectLegacyShipments() {
  const { id } = useParams();
  const { pathname } = useLocation();
  return <Navigate to={legacyShipmentsRedirect(pathname, id)} replace />;
}
